import { render } from "./BreadcrumbPage.vue?vue&type=template&id=2dd2158e&ts=true"
import script from "./BreadcrumbPage.vue?vue&type=script&lang=ts"
export * from "./BreadcrumbPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__